import React from "react";

const Status = () => {
    return (
        <div>
            <h1>Welcome to the Page</h1>
            <p>This is a protected route. You must be logged in to see this page.</p>
        </div>
    );
}
export default Status;